import { type RecoilValue, type RecoilValueReadOnly, useRecoilValueLoadable } from 'recoil';

export function useAsyncRecoilValue<T>(
    state: RecoilValue<T> | RecoilValueReadOnly<T>
): [value: T | undefined, isLoading: boolean, promise: Promise<T>] {
    const loadable = useRecoilValueLoadable(state);
    if (loadable.state === 'hasError') throw loadable.errorMaybe();

    const value = loadable.valueMaybe();
    const isLoading = loadable.state === 'loading';

    return [value, isLoading, loadable.toPromise()];
}
